import Axios from './axios_wrapper'

// Register a new user
export function createRegistration(data) {
  return Axios({
    url: `/users/registrations`,
    method: 'POST',
    data
  })
}

// Email verification to complete user registration
export function verifyEmail(user) {
  return Axios({
    url: `/users/verify_email`,
    method: 'PATCH',
    data: user
  })
}



//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/api/registrations.js
// module id = null
// module chunks = 